<template>
    <div class="taskBox">
        <div v-for="data in myData" class="flexStartUp" style="width: 100%">
            <div v-for="data in myData" class="flexStartUp" style="width: 700px; margin: 0 auto;">

                <div style="flex: 1; margin-left: 20px">
                    <table align='center'>
                        <tr>
                            <td colspan="5" style="color: #6495ED;">
                                还有<span style="font-size: 30px; color: orangered;">{{ data.notsp }}</span>人等待缴费
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" style="color: #6495ED; text-align: center;">您的收费统计</td>
                        </tr>
                        <tr>
                            <td>专业名称</td>

                            <td>已缴费人数</td>
                            <td>学杂费</td>
                            <td>赞助费</td>
                            <td>总计</td>

                        </tr>
                        <tr v-for="(m, idx2) in data.majors" :key="idx2">
                            <td>{{ m.item_num }} {{ m.title }}</td>

                            <td> {{ m.count }}</td>

                            <td> {{ m.total_money }}</td>

                            <td> 0</td>
                            <td> {{ m.total_money }}</td>

                        </tr>


                    </table>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    data() {
        return {
            myData: []
        }
    },
    mounted() {
        this.getTask()
    },
    methods: {
        getTask() {
            this.$http.post("/api/get_teacher_task", { type: "shoufei" }).then(res => {
                let rdata = { ...res.data }
                if (rdata.majors && rdata.majors.length > 0) {
                    let obj = {}
                    obj.title = "合计"
                    obj.count = 0
                    obj.stu_count = 0
                    obj.total_money = 0

                    rdata.majors.map(a => {
                        obj.count += a.count
                        obj.total_money += a.total_money
                    })

                    rdata.majors.push(obj)
                }
                this.myData = [rdata]
            })
        }
    },
}
</script>
<style scoped="scoped">
tr td:nth-child(4) {
    border-right: 1px solid #6495ED;
}

tr td:nth-child(5) {
    border-right: 1px solid #6495ED;
}
</style>
